import { changeNum } from '../../common/function';
import '../../css/app.css'
import '../../css/main.css'
import '../../css/common.css'
import '../../css/payment.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Link, useNavigate } from "react-router-dom"
import { ChevronDown, ChevronUp } from 'lucide-react';

import useWindowSize from '../../hook/useWindowSize';

function DownloadBtn({ text, onClick, height = "36px", state = true }) {
    return (
        <div className="excel_download" onClick={state ? onClick : undefined} style={{ opacity: state ? "1" : "0.7", position: "relative" }}>
            <img src='/img/excel_img.png' className='btn btn-outline-secondary' style={{ height: height, padding: '0', cursor: state ? "pointer" : "auto" }} />
        </div>
    )
}

function CountSelect({ onChange }) {
    return (
        <div className="rows_per_page">
            <select id="page_size" className="form-select select_status" onChange={onChange}>
                <option value="10">10개씩 보기</option>
                <option value="30">30개씩 보기</option>
                <option value="50">50개씩 보기</option>
                <option value="100">100개씩 보기</option>
            </select>
        </div>
    )
}

function TotalAmountCount({ confirm_amt, confirm_cnt, canceled_amt, canceled_cnt }) {
    return (
        <>
            <div className="input_wrap" style={{ background: "#d7e3cf", flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginBottom: '5px' }}>
                    <label>승인금액 :</label>
                    <input id="confirm_amt" type="text" className="form-control" value={`${confirm_cnt}건`} readonly="" disabled="" style={{ textAlign: "right" }} />
                </div>
                <input id="confirm_amt" type="text" className="form-control" value={`${changeNum(confirm_amt)}원`} readonly="" disabled="" style={{ textAlign: "right" }} />
            </div>
            <div className="input_wrap" style={{ background: "#fcd9d6", flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginBottom: '5px' }}>
                    <label>취소금액 :</label>
                    <input id="confirm_amt" type="text" className="form-control" value={`${canceled_cnt}건`} readonly="" disabled="" style={{ textAlign: "right" }} />
                </div>
                <input id="canceled_amt" type="text" className="form-control" value={changeNum(canceled_amt)} readonly="" disabled="" style={{ textAlign: "right" }} />
            </div>
            <div className="input_wrap" style={{ background: "#d2e4fb", flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginBottom: '5px' }}>
                    <label>합계 :</label>
                    <input id="confirm_amt" type="text" className="form-control" value={`${confirm_cnt + canceled_cnt}건`} readonly="" disabled="" style={{ textAlign: "right" }} />
                </div>
                <input id="tot_amt" type="text" className="form-control" value={changeNum(confirm_amt - canceled_amt)} readonly="" disabled="" style={{ textAlign: "right" }} />
            </div>
        </>
    )
}


function TotalAmount({ confirm_amt, canceled_amt }) {
    const { Rwidth, Rheight } = useWindowSize();

    const [state, setState] = useState(Rwidth > 768 ? true : false)
    const [dropDown, setDropDown] = useState(false)

    useEffect(() => {
        if (Rwidth > 768) {
            setState(true)
        }
        else {
            setState(false)
        }
    }, [Rwidth])

    return (
        <>
            {
                state
                    ?
                    <>
                        <div className="input_wrap" style={{ background: "#d7e3cf" }}>
                            <label>승인금액 :</label>
                            <input id="confirm_amt" type="text" className="form-control" value={changeNum(confirm_amt)} readonly="" disabled="" />
                        </div>
                        <div className="input_wrap" style={{ background: "#fcd9d6" }}>
                            <label>취소금액 :</label>
                            <input id="canceled_amt" type="text" className="form-control" value={changeNum(canceled_amt)} readonly="" disabled="" />
                        </div>
                        <div className="input_wrap" style={{ background: "#d2e4fb" }}>
                            <label>합계 :</label>
                            <input id="tot_amt" type="text" className="form-control" value={changeNum(confirm_amt - canceled_amt)} readonly="" disabled="" />
                        </div>
                    </>
                    :
                    <>

                        <div className="input_wrap" style={{ background: "#d2e4fb", position: "relative" }} onClick={() => setDropDown(e => !e)}>
                            <label>합계 :</label>
                            <input id="tot_amt" type="text" className="form-control" value={changeNum(confirm_amt - canceled_amt)} readonly="" disabled="" style={{ paddingRight: "13px" }} />
                            {
                                dropDown
                                    ?
                                    <button type="button" className="btn_more" style={{ position: "absolute", top: "50%", right: "5px", transform: "translateY(-50%)" }}>
                                        <ChevronUp />
                                    </button>
                                    :
                                    <button type="button" className="btn_more" style={{ position: "absolute", top: "50%", right: "5px", transform: "translateY(-50%)" }}>
                                        <ChevronDown />
                                    </button>
                            }
                        </div>
                        {
                            dropDown
                                ?
                                <>
                                    <div className="input_wrap" style={{ background: "#d7e3cf" }}>
                                        <label>승인금액 :</label>
                                        <input id="confirm_amt" type="text" className="form-control" value={changeNum(confirm_amt)} readonly="" disabled="" style={{ paddingRight: "13px" }} />
                                    </div>
                                    <div className="input_wrap" style={{ background: "#fcd9d6" }}>
                                        <label>취소금액 :</label>
                                        <input id="canceled_amt" type="text" className="form-control" value={changeNum(canceled_amt)} readonly="" disabled="" style={{ paddingRight: "13px" }} />
                                    </div>
                                </>
                                :
                                ""
                        }
                    </>
            }
        </>
    )
}

function CountAmount({ tableBodyData }) {
    let len = 0
    if (Array.isArray(tableBodyData)) {
        len = tableBodyData.length;
    } else {
        len = tableBodyData;
    }
    return (
        <div className="tabulator_total_cnt_wrap d_none">
            <input id="total_cnt" type="text" value={`${len}건`} readonly="" />
        </div>
    )
}

function CountAmountLeft({ tableBodyData, textAlign = "left" }) {
    let len = 0
    if (Array.isArray(tableBodyData)) {
        len = tableBodyData.length;
    } else {
        len = tableBodyData;
    }
    return (
        <div class="excel_download">
            <div class="tabulator_total_cnt_wrap">
                <input id="total_cnt" type="text" value={`${len}건`} readonly="" style={{ textAlign: textAlign }} />
            </div>
        </div>
    )
}
export { DownloadBtn, CountSelect, TotalAmount, CountAmount, CountAmountLeft, TotalAmountCount }